import React, { useState, useEffect } from 'react';
import { Form, useParams } from 'react-router-dom';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import NavigationUser from '../../Layouts/Navigation/NavigationUser'
import { Container, Typography, Box, Grid, Paper, Table, TableBody, TableCell, 
    TableContainer, TableHead, TableRow, TablePagination, Button, Dialog, DialogActions, 
    DialogContent, DialogContentText, DialogTitle, TextField, Alert, Snackbar,
    FormControl, InputLabel, MenuItem, FormHelperText, Select} from '@mui/material';
import { format, min } from 'date-fns';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import PostAddIcon from '@mui/icons-material/PostAdd';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import { BASE_URL } from '../../utils/constants';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';


function OrdersControl() {
  return (
    <>
      <NavigationUser/>
      <Container>
        <Box sx={{ marginLeft: '100px', marginRight: '50px' }}>
          <Typography variant="h6" gutterBottom className="centerText">
              Pedidos
          </Typography>
      </Box>
      </Container>
    </>
  )
}

export default OrdersControl